import React from 'react';
import { motion } from 'framer-motion';
import { Target, Video, CheckCircle2, Gift } from 'lucide-react';
const bonuses = [{
  label: 'Bonus 1',
  icon: Target,
  title: 'Estructura de Campañas para vender iPhones con Instagram Ads',
  desc: 'Una guía complementaria enfocada 100% en la parte de campañas publicitarias: cómo armarlas, organizarlas, testearlas y optimizarlas para vender iPhones.',
  points: ['Qué tipo de campañas usar para vender iPhones.', 'Cuándo usar campañas de mensajes y cuándo tráfico al perfil.', 'Cómo elegir el producto o modelo a anunciar.', 'Cómo dividir campañas por objetivo y organizar anuncios por ángulo.', 'Cómo pensar el presupuesto inicial.', 'Cómo medir costo por conversación y calidad de los mensajes.', 'Qué hacer cuando llegan muchos mensajes pero pocas ventas.', 'Qué hacer cuando una campaña no genera conversaciones.', 'Errores típicos al lanzar campañas y cómo evitarlos.']
}, {
  label: 'Bonus 2',
  icon: Video,
  title: 'Creación de Contenido para vender iPhones con Reels y Anuncios',
  desc: 'Cómo crear el contenido que después usás como anuncio. Pensado para reels y publicaciones que comuniquen valor real y atraigan compradores.',
  points: ['Diferencia entre contenido orgánico y contenido publicitario.', 'Cómo usar reels para atraer compradores de iPhone.', 'Cómo crear hooks fuertes y hablarle al comprador correcto.', 'Cómo usar problemas reales del cliente como idea de contenido.', 'Cómo crear contenido sobre plan canje, primer iPhone, cambio de modelo y financiación.', 'Cómo crear contenido para responder objeciones frecuentes.', 'Cómo estructurar guiones con la fórmula Atención / Problema / Solución / CTA.', 'Cómo convertir contenido orgánico en anuncios.']
}];
export function Bonus() {
  return <section className="py-20 md:py-28 bg-white border-t border-zinc-200" data-id="element-83">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-85">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-600 rounded-full mb-6" data-id="element-86">
            <Gift className="w-6 h-6" data-id="element-87" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 tracking-tight mb-4" data-id="element-88">
            Además, te llevás 2 bonus prácticos
          </h2>
          <p className="text-lg text-zinc-600 text-balance" data-id="element-89">
            Dos recursos complementarios pensados para que tengas las dos piezas
            que faltan al lado de la guía principal: las campañas y el
            contenido.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-90">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-zinc-50 rounded-3xl p-7 md:p-9 border border-zinc-200 flex flex-col" data-id="element-91">
                <div className="flex items-center gap-3 mb-5" data-id="element-92">
                  <div className="w-11 h-11 rounded-xl bg-blue-600 text-white flex items-center justify-center shrink-0" data-id="element-93">
                    <Icon className="w-5 h-5" data-id="element-94" />
                  </div>
                  <span className="text-xs font-bold text-blue-600 uppercase tracking-wider" data-id="element-95">
                    {bonus.label}
                  </span>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-zinc-900 mb-3 leading-tight" data-id="element-96">
                  {bonus.title}
                </h3>
                <p className="text-zinc-600 mb-6 leading-relaxed" data-id="element-97">
                  {bonus.desc}
                </p>
                <ul className="space-y-2.5 mt-auto" data-id="element-98">
                  {bonus.points.map((p, i) => <li key={i} className="flex items-start gap-2.5 text-sm" data-id="element-99">
                      <CheckCircle2 className="w-4 h-4 text-blue-600 shrink-0 mt-0.5" data-id="element-100" />
                      <span className="text-zinc-700 leading-relaxed" data-id="element-101">{p}</span>
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}